import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import StatusComp from "../../../components/StatusComp";
import CommonDatePicker from "../../../components/CommonDatePicker";
import SelectBox from "../../../components/SelectBox";
import { groupUsers, siteDetails } from "../../redux/api/dummyJson";
import { get, post } from "../../../Services/ApiHandler";
import { URL } from "../../../Services/Constant";
import toast from "react-hot-toast";
import UserReportPage from "../../KnfSuperAdmin/Report/UserReportPage";
import CommonDatePickerReports from "../../../components/CommonDatePickerReports";

const CompanyUserReport = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);

  const [data, setData] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [siteList, setSiteList] = useState([]);

  const type = location?.state?.type;

  const createdAt = moment().format("DD-MM-YYYY");

  const [cameraList, setCameraList] = useState([]);
  const [camTypes, setCamTypes] = useState([]);
  const [selecetdCam, setSelectedCam] = useState(null);
  const [siteData, setSiteData] = useState([]);
  const [reportData, setReportData] = useState({});

  const getSiteList = () => {
    get(URL.ACTIVE_SITE + "?knf_type=1")
      .then((res) => {
        setSelectedOption([]);
        if (res?.sites?.length > 0) {
          setSiteList(res?.sites);
        } else {
          setSiteList([]);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    getSiteList();
  }, []);

  const handlePreview = () => {
    if (!selectedOption?.value) {
      toast.error("Please Select Site");
      return;
    }

    if (!fromDate) {
      toast.error("Please Select From Date");
      return;
    }

    if (!toDate) {
      toast.error("Please Select To Date");
      return;
    }

    let formdata = new FormData();
    formdata.append("from_date", moment(fromDate).format("YYYY-MM-DD"));
    formdata.append("to_date", moment(toDate).format("YYYY-MM-DD"));
    formdata.append("site_id", selectedOption?.value);

    if (selecetdCam?.value) {
      formdata.append("camera_id", selecetdCam?.value);
    }

    post(URL.GET_USER_REPORT_ADMIN, formdata)
      .then((res) => {
        if (res?.data) {
          setReportData(res?.data);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getCameraList = (site_id) => {
    if (!site_id) {
      setSelectedCam(null);
      return;
    } else {
      setSelectedCam({ label: "All", value: "" });
    }
    let formdata = new FormData();
    formdata.append("site_id", site_id?.value);
    post(URL.CAMERA_LISTS, formdata)
      .then((res) => {
        if (res?.cameras?.length > 0) {
          let temp = [];
          res?.cameras?.map((item, ind) => {
            let obj_ = {
              ...item,
              name_old: item?.name,
              name: `${item?.code} - ${item?.name}`,
            };
            temp.push(obj_);
          });
          let arr = [{ name: "All", id: "" }, ...temp];
          console.log("arr", arr);
          setCameraList(arr);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  return (
    <div className="dashRightView">
      <StatusComp name={"User"} type={"Report"} />
      <div className={"d-flex col-md-12 ac-jb gap-5"}>
        <div className="col-md-2">
          <label className="form-label">Select Site</label>
          <SelectBox
            arrayData={siteList}
            data={siteData}
            setData={setSiteData}
            selectedOption={selectedOption}
            setSelectedOption={(val) => {
              setSelectedOption(val);
              getCameraList(val);
              setReportData({});
            }}
            style={true}
          />
        </div>

        <CommonDatePickerReports
          fromDate={fromDate}
          toDate={toDate}
          setFromDate={(even) => {
            setFromDate(even);
            setReportData({});
          }}
          setToDate={(even) => {
            setToDate(even);
            setReportData({});
          }}
        />

        <div className="col-md-2">
          <label className="form-label">Select Camera</label>
          <SelectBox
            arrayData={cameraList}
            data={camTypes}
            setData={setCamTypes}
            selectedOption={selecetdCam}
            setSelectedOption={(even) => {
              setSelectedCam(even);
              setReportData({});
            }}
            style={true}
          />
        </div>

        {/* Preview Button */}
        <div className="col-md-1 mt-4 ">
          <button onClick={handlePreview} className="submit-btn">
            Preview
          </button>
        </div>
      </div>

      {reportData?.company ? (
        <UserReportPage data={reportData} />
      ) : (
        <div
          className={`card shadow-sm border-0 rounded-4 mt-5 ${!selectedOption?.value && "opacity-25"}`}
        >
          <div className="card-body text-center py-5">
            <div className="mb-3">
              <div className="bg-light rounded-circle d-inline-flex p-4">
                <i className="bi bi-file-earmark-bar-graph fs-1 text-muted"></i>
              </div>
            </div>
            <h5 className="text-muted mb-2">No Report Generated</h5>
            <p className="text-muted small mb-0">
              Select date range and click "Preview Report" to view user activity
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default CompanyUserReport;
